<template>
  <div class="h-screen flex w-full padded">
    <div class="vx-col flex items-center justify-center flex-col mx-auto text-center">
      <img src="https://cdn.redgirasol.com/green/IMAGENES/ERROR404-01.png" alt="graphic-404" class="mx-auto mb-4 max-w-full mb-20px">
      <h1 class="mx-auto mb-25px bold">404 - Página no encontrada</h1>
      <p class="error-subtitle mb-15px">Lo sentimos, no encontramos la luz en esta dirección.</p>
      <router-link to="/" class="rg-rounded-btn">Volver al inicio</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFoundPage"
}
</script>

<style >
  .h-screen {
    height: 100vh!important;
  }
  .w-full {
    width: 100%;
  }
  .padded {
    padding-left: 20px;
    padding-right: 20px;
  }
  .mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .justify-center {
    justify-content: center !important;
  }
  .items-center {
    align-items: center !important;
  }
  .max-w-full {
    max-width: 100%!important;
  }
  .flex-col {
    flex-direction: column !important;
  }
  .flex {
    display: flex !important;
  }
  .error-subtitle {
    font-size: 15px;
  }
</style>